import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography, Divider} from '@mui/material';
import FieldView2 from 'core/components/layout/FieldView2';
import {transformDateValue} from 'core/js/FormUtils';


export default function OtherInfo() {
  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
  useEffect(() => {
  }, [productObj]);

  return (
      <Grid sx={{ backgroundColor: 'white', borderRadius: 2, m:1, p:1, }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', }}>
          Other Information
        </Typography>
        <Divider sx={{ borderStyle: 'dotted', mb: 1 }} />
        <Grid container direction="row" sx={{ width: '100%' }}>
          <Grid item lg={6} md={6} sm={6} xs={6} ><FieldView2 label="Batch Number" value={productObj.batchnumber} /></Grid>
          <Grid item lg={6} md={6} sm={6} xs={6} ><FieldView2 label="Expiry Date" value={transformDateValue(productObj.expirydate)} /></Grid>
          <Grid item  lg={6} md={6} sm={6} xs={6} ><FieldView2 label="Set" value={productObj?.setname || "-"} /></Grid>
          <Grid item  lg={6} md={6} sm={6} xs={6} ><FieldView2 label="Color" value={productObj?.liquidcolor || "-"} /></Grid>
          <Grid item  lg={6} md={6} sm={6} xs={6} ><FieldView2 label="Manuf Date" value={transformDateValue(productObj?.manufdate) || "-"} /></Grid>
          <Grid item  lg={6} md={6} sm={6} xs={6} ><FieldView2 label="Executive" value={productObj?.executivename || "-"} /></Grid>

        </Grid>
      </Grid>
  );
}